
import React from "react";
import { DashboardMetrics } from "./DashboardMetrics";
import { DashboardTabs } from "./DashboardTabs";
import { SubscriptionManagement } from "./SubscriptionManagement";

export function DashboardContent() {
  // Default data - in a real app, this would come from API calls
  const defaultActiveRequests = [];
  const defaultCompletedRequests = [];
  const defaultActiveRequestsCount = 0;
  const defaultSuccessRate = 0;
  const defaultTotalRefunded = 0;

  return (
    <div className="space-y-6 lg:space-y-8">
      {/* Metrics Grid - Mobile Optimized */}
      <div className="px-4 sm:px-0">
        <DashboardMetrics 
          activeRequestsCount={defaultActiveRequestsCount}
          successRate={defaultSuccessRate}
          totalRefunded={defaultTotalRefunded}
        />
      </div>
      
      {/* Subscription Management - Mobile Optimized */}
      <div className="px-4 sm:px-0">
        <SubscriptionManagement />
      </div>
      
      {/* Dashboard Tabs - Mobile Optimized */}
      <div className="px-4 sm:px-0">
        <DashboardTabs 
          activeRequests={defaultActiveRequests}
          completedRequests={defaultCompletedRequests}
        />
      </div>
    </div>
  );
}
